import React, { useContext, useState, useEffect, useMemo } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link, useLocation, useHistory } from "react-router-dom";

import Repo from "../../Utility/Repo";
import {
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "design-react-kit";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
//import ListIsee from "../../Components/ListIsee";
import ListUsers from "../../Components/ListUsers";
import UploadFile from "../../Components/UploadFile";
import StateTranslate from "../../Components/StateTranslate";
import LabelsLoader from "../../Utility/labelsLoader";
import { AlertMessage, showError } from "../../Components/AlertMessage";
import IO from "../../Assets/Img/IO.svg";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function AnnouncementDetail(props) {
  const history = useHistory();

  const apiToken = useContext(TokenContext);
  let query = useQuery();
  const announcementId = useMemo(() => query.get("id"), [query]);
  const [changeArray, setChangeArray] = useState(false);
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState({});
  const [sessionSubscription, setSessionSubscription] = useState({});
  const [sessionSubscriptionTemp, setSessionSubscriptionTemp] = useState();
  const [sessionSubscriptionTemp2, setSessionSubscriptionTemp2] = useState();
  const [service, setService] = useState({});
  const [id, setId] = useState();
  const [errorImport, setErrorImport] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [isOpenImport, toggleModalImport] = useState(false);
  const [isOpenCSVUpload, toggleModalCSVUpload] = useState(false);
  const [isOpenCSVEmail, toggleModalCSVEmail] = useState(false);
  const [isOpenCSVIO, toggleModalCSVIO] = useState(false);

  const [isOpenRendicontazione, toggleModalRendicontazione] = useState(false);
  const [isOpenCoupon, toggleModalCoupon] = useState(false);
  const [showFileToggle, toggleModalShowFile] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [subscribeError, setSubscribeError] = useState(false);
  const [alertShow, setAlertShow] = useState(false);
  const [uploadImport, setUploadImport] = useState();
  const [errorMessageImport, setErrorMessageImport] = useState(false);
  const [isUpdateIsees, setIsUpdateIsees] = useState(false);
  const [isRemoveOldSubscriptions, setIsRemoveOldSubscriptions] =
    useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [paymentFiles, setPaymentFiles] = useState([]);

  const [showFiles, setShowFiles] = useState(false);

  const [apiError, setApiError] = useState({});
  const handleAlertClose = () => {
    setApiError({ isVisible: false, message: "" });
  };
  const [isOpenSubscribeUserOperator, toggleModalSubscribeUserOperator] =
    useState(false);

  const [sub, setSub] = useState({});

  const downloadPreview = () => {
    Repo.downloadPreview(apiToken, id, filterMonth, filterSubscribed)
      .then((response) => {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "text/csv" }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Template_" + new Date().toLocaleDateString("it-IT") + ".csv",
          );
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const downloadPreviewNotify = () => {
    Repo.downloadPreviewNotify(apiToken, id, filterMonth, filterSubscribed)
      .then((response) => {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "text/csv" }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Notifiche_" + new Date().toLocaleDateString("it-IT") + ".csv",
          );
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [sendFile, setSendFile] = useState({
    fileContentBase64: "",
    contentType: "csv",
    updateIsees: isUpdateIsees,
    removeOldSubscriptions: isRemoveOldSubscriptions,
    mese: "",
  });
  function getMonthName(monthNumber) {
    const mesi = [
      "Gennaio",
      "Febbraio",
      "Marzo",
      "Aprile",
      "Maggio",
      "Giugno",
      "Luglio",
      "Agosto",
      "Settembre",
      "Ottobre",
      "Novembre",
      "Dicembre",
    ];
    // monthNumber può essere "01", "02", ... "12"
    const index = parseInt(monthNumber, 10) - 1;
    if (index >= 0 && index < 12) {
      return mesi[index];
    }
    return monthNumber;
  }
  const labels = LabelsLoader();

  const [filter, setFilter] = useState({
    firstName: "",
    lastName: "",
    fiscalCode: "",
    email: "",
    phoneNumber: "",
  });

  const [filterSubscribed, setFilterSubscribed] = useState({
    firstName: "",
    lastName: "",
    fiscalCode: "",
    confirmed: "",
    nProtocollo: "",
    descrizione: "",
    city: "",
    mese: String(new Date().getMonth() + 1).padStart(2, "0"),
  });

  const [filterMonth, setFilterMonth] = useState(
    String(new Date().getMonth() + 1).padStart(2, "0"),
  );

  const paymentReferenceDate = useMemo(() => {
    const rawMonth = parseInt(filterMonth, 10);
    const baseYear = Number(session?.anno) || new Date().getFullYear();

    if (Number.isNaN(rawMonth)) {
      return {
        mese: String(new Date().getMonth() + 1).padStart(2, "0"),
        anno: baseYear,
        data: "",
      };
    }

    const normalizedMonth = rawMonth > 12 ? rawMonth - 12 : rawMonth;
    const normalizedYear = rawMonth > 12 ? baseYear + 1 : baseYear;
    const mese = String(normalizedMonth).padStart(2, "0");

    return {
      mese,
      anno: normalizedYear,
      data: `${mese}/${normalizedYear}`,
    };
  }, [filterMonth, session?.anno]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Puoi impostare 'auto' per uno scorrimento immediato
    });
  };

  useEffect(() => {
    if (subscribeError) {
      const timer = setTimeout(() => {
        setSubscribeError(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [subscribeError]);

  useEffect(() => {
    if (!apiToken || !announcementId) return;

    Repo.getPaymentFile(apiToken, announcementId, filterMonth)
      .then((response) => {
        setPaymentFiles(response.data || []);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [apiToken, announcementId, filterMonth]);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const apiGet = () => {
    if (!apiToken || !announcementId) return;

    setId(announcementId);
    setLoading(false);

    Repo.getSessionById(apiToken, announcementId)
      .then((response) => {
        if (response.status === 200) {
          setSession(response.data);

          const sortedSubscriptions = [
            ...(response.data.subscriptions || []),
          ].sort((a, b) => a.rankingScore - b.rankingScore);

          setSessionSubscriptionTemp(sortedSubscriptions);
          setSessionSubscriptionTemp2(sortedSubscriptions);

          return Repo.getOneServices(apiToken, response.data.service.id);
        }

        return null;
      })
      .then((serviceResponse) => {
        if (serviceResponse && serviceResponse.status === 200) {
          setService(serviceResponse.data);
        }
      })
      .catch((error) => {
        setApiError({ isVisible: true, message: showError(error) });
      })
      .finally(() => {
        setLoading(true);
      });
  };
  const renderPaymentFiles = () => {
    if (!paymentFiles || paymentFiles.length === 0 || !showFiles) return null;
    return (
      <div className="mt-4">
        <h5>File Cronologia Pagamenti</h5>
        <div
          className="shadow-sm bg-white mb-3"
          style={{ borderRadius: "10px", border: "1px solid #e5e5e5" }}
        >
          {paymentFiles.map((file, idx) => (
            <div key={idx} className="border-bottom">
              <div className="card-body d-flex align-items-center justify-content-between p-3">
                <div className="d-flex align-items-center">
                  <svg
                    className="icon icon-primary mr-2"
                    style={{ width: 28, height: 28 }}
                  >
                    <use href={`${iconSprite}#it-file`} />
                  </svg>
                  <div>
                    <div style={{ fontWeight: 500 }}>
                      {abbreviateFileName(
                        file.storageFile?.name || `File ${idx + 1}`,
                      )}
                    </div>
                    {file.storageFile?.created ||
                    file.storageFile?.dataInsert ? (
                      <div
                        className="text-muted"
                        style={{ fontSize: "0.85em" }}
                      >
                        {new Date(
                          file.storageFile.created ||
                            file.storageFile.dataInsert,
                        ).toLocaleDateString("it-IT")}
                      </div>
                    ) : null}
                  </div>
                </div>
                <button
                  className="btn btn-outline-primary"
                  style={{ minWidth: 140 }}
                  onClick={() =>
                    showFile(
                      file.storageFile.id || file.storageFileId,
                      file.storageFile.name,
                    )
                  }
                >
                  Visualizza / Scarica
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  useEffect(() => {
    apiGet();
  }, [apiToken, announcementId]);

  const subscribeUser = (sub) => {
    let obj = {
      userId: sub.id,
      announcementId: session.id,
    };

    Repo.postSubscribeUserFromOperator(apiToken, JSON.stringify(obj))
      .then((response) => {
        if (response.status == 200) {
          window.location.reload();
          setSubscribeError(false);
        }
      })
      .catch((error) => {
        toggleModalSubscribeUserOperator(false);
        toggleModal(false);
        scrollToTop();
        setApiError({ isVisible: true, message: showError(error) });
      });
  };

  const sendGenerateCoupons = () => {
    let obj = {
      announcementId: session.id,
      title: toggleTitle.value,
      valore: toggleValore.value,
      maxMonthlyUsage: toggleMaxMonthlyUsage.value,
      // executiveId: previouslySelectedOption.value,
    };

    setLoading(false);
    Repo.generateCoupons(apiToken, obj)
      .then((response) => {
        if (response.status == 200) {
          toggleModalCoupon(false);
          setLoading(true);
          alert("Buoni creati correttamente!");
        }
      })
      .catch((error) => {
        setLoading(true);
        setErrorMessageImport(error);
      });
  };

  const sendFilter = () => {
    setLoading(false);
    Repo.getUsersList(apiToken, filter)
      .then((response) => {
        if (response.status == 200) {
          setUsersList(response.data);
          setLoading(true);
        }
      })
      .catch((error) => {
        setLoading(true);
        setApiError({ isVisible: true, message: showError(error) });
      });
  };

  const sendUrlPage = (url) => {
    var url2 = "";
    const location = window.location.href;
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      // dev code
      let _url = props.subfolder + url;
      url2 = _url; //props.subfolder + _url + "?urlBack=" + location;

      //process.env.PUBLIC_URL +
    } else {
      let _url = props.subfolder + url;

      url2 = _url + "?urlBack=" + location;
    }
    const newTab = window.open(url2, "_blank");
    newTab.focus();
  };

  const downloadList = () => {
    setLoading(false);
    Repo.getListSubscription(apiToken, id)
      .then((response) => {
        if (response.status == 200) {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "text/csv" }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "listaUtenti_" + session.name + ".csv");
          document.body.appendChild(link);
          link.click();
          setLoading(true);
        }
      })
      .catch((error) => {
        setLoading(true);
        setApiError({ isVisible: true, message: showError(error) });
      });
  };

  const bodyGenerateCoupons = () => {
    return (
      <>
        <div className="row">
          <div className="col-12">
            <label htmlFor="toggleTitle">Nome buono servizio:</label>
            <input
              type="text"
              id="toggleTitle"
              name="toggleTitle"
              value={session.name}
              readOnly
            />
          </div>

          <div className="col-6">
            <label htmlFor="toggleMaxMonthlyUsage">
              Numero massimo di utilizzi:
            </label>
            <input
              type="number"
              id="toggleMaxMonthlyUsage"
              name="toggleMaxMonthlyUsage"
            />
          </div>

          <div className="col-6">
            <label htmlFor="toggleValore">Valore:</label>
            <input type="number" id="toggleValore" name="toggleValore" />
          </div>
        </div>

        {errorMessageImport && (
          <div className="text-danger">Buoni generati correttamente</div>
        )}
      </>
    );
  };

  const bodyImport = () => {
    return (
      <>
        <div className="row">
          <div className="form-check col-lg-6 offset-lg-3 mb-5">
            <label htmlFor="mese" className="form-label">
              Seleziona mese di riferimento*
            </label>
            <select
              id="mese"
              name="mese"
              className="form-control custom-textarea"
              value={sendFile.mese}
              onChange={(e) =>
                setSendFile({ ...sendFile, mese: e.target.value })
              }
              required
            >
              <option value="">Seleziona il mese</option>
              <option value="01">Gennaio</option>
              <option value="02">Febbraio</option>
              <option value="03">Marzo</option>
              <option value="04">Aprile</option>
              <option value="05">Maggio</option>
              <option value="06">Giugno</option>
              <option value="07">Luglio</option>
              <option value="08">Agosto</option>
              <option value="09">Settembre</option>
              <option value="10">Ottobre</option>
              <option value="11">Novembre</option>
              <option value="12">Dicembre</option>
            </select>
          </div>
        </div>
        <div className="row">
          <div className="col d-flex justify-content-center">
            <UploadFile
              setErrorMessage={setErrorMessageImport}
              typeFile={["text/csv"]}
              handleFile={setUploadImport}
              testoCaricamento="File caricato correttamente"
              testoInterno="Seleziona file dal dispositivo"
              testoTitolo="Carica CSV"
            ></UploadFile>
            {errorMessageImport && (
              <div className="text-danger">
                Carica un file con un formato supportato
              </div>
            )}
            {!uploadImport && errorImport && (
              <div className="text-danger">Nessun file caricato</div>
            )}
          </div>
        </div>
      </>
    );
  };

  const uploadList = () => {
    let passedValidation = true;
    setErrorImport(true);
    setLoading(false);

    let tempData = sendFile;
    tempData["fileContentBase64"] = isUpdateIsees;
    tempData["isUpdateIsees"] = isUpdateIsees;
    tempData["removeOldSubscriptions"] = isRemoveOldSubscriptions;

    if (uploadImport) {
      var splitBase64 = uploadImport.split(",");
      tempData["fileContentBase64"] = splitBase64[1];
    } else {
      passedValidation = false;
      setLoading(true);
    }

    if (passedValidation) {
      Repo.postCSVImport(apiToken, JSON.stringify(tempData), query.get("id"))
        .then((response) => {
          if (response.status == 200) {
            if (isUpdateIsees) {
              setIsUpdateIsees(true);
            } else if (isRemoveOldSubscriptions) {
              setIsRemoveOldSubscriptions(true);
            } else {
              setIsUpdateIsees(false);
              setIsRemoveOldSubscriptions(false);
            }

            window.location.reload();
          }
        })
        .catch((error) => {
          setLoading(true);
          toggleModalImport(false);
          setApiError({ isVisible: true, message: showError(error) });
        });
    }
  };

  const returnBodyModal = () => {
    return (
      <>
        <div className="row">
          <div className="col-lg-4">
            <Input
              id="first_name"
              required
              label="Nome"
              type="text"
              name="first_name"
              onChange={(e) =>
                setFilter({ ...filter, firstName: e.target.value })
              }
            />
          </div>
          <div className="col-lg-4">
            <Input
              id="last_name"
              required
              label="Cognome"
              type="text"
              name="last_name"
              onChange={(e) =>
                setFilter({ ...filter, lastName: e.target.value })
              }
            />
          </div>
          <div className="col-lg-4">
            <Input
              id="fiscal_code"
              required
              label="Codice Fiscale"
              type="text"
              name="fiscal_code"
              onChange={(e) =>
                setFilter({ ...filter, fiscalCode: e.target.value })
              }
            />
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-lg-6">
            <Input
              id="email"
              required
              label="Email"
              type="text"
              name="email"
              onChange={(e) => setFilter({ ...filter, email: e.target.value })}
            />
          </div>
          <div className="col-lg-6">
            <Input
              id="phone_number"
              required
              label="Telefono"
              type="text"
              name="phone_number"
              onChange={(e) =>
                setFilter({ ...filter, phoneNumber: e.target.value })
              }
            />
          </div>
        </div>
        <div className="row mt-2 text-center">
          <div className="col-lg-12 clearfix">
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={sendFilter}
            >
              <span className="align-middle">Ricerca</span>
            </button>
          </div>
        </div>
        {usersList && usersList.length > 0 ? (
          <>
            <table className="table table-hover" style={{ cursor: "pointer" }}>
              <thead>
                <tr>
                  <th scope="col">Codice Fiscale</th>
                  <th scope="col">Nome</th>
                  <th scope="col">Cognome</th>
                  <th scope="col">Email</th>
                </tr>
              </thead>
              <tbody>
                {usersList.map((x, index) => (
                  <React.Fragment key={index}>
                    <tr
                      onClick={() => {
                        toggleModalSubscribeUserOperator(
                          !isOpenSubscribeUserOperator,
                        );
                        setSub(x);
                      }}
                    >
                      <th scope="row">{x.fiscalCode}</th>
                      <td>{x.firstName}</td>
                      <td>{x.lastName}</td>
                      <td>{x.email}</td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </>
        ) : (
          <>
            <span className="text">Nessun utente trovato</span>
            <div className="clear"></div>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                sendUrlPage("/lista_utenti/nuovo_utente");
              }}
            >
              {" "}
              Nuovo utente
            </a>
          </>
        )}
      </>
    );
  };

  const bodyFile = () => {
    return (
      <object
        width="100%"
        height="900"
        data={file && file.data}
        type={file && file.type}
      ></object>
    );
  };

  const showFile = (id, fileName) => {
    Repo.downloadFileOperator(apiToken, id)
      .then((response) => {
        if (response.status === 200) {
          const byteCharacters = atob(response.data);
          if (response.headers["content-type"].includes("csv")) {
            setCsvContent(byteCharacters);
            setShowCsvModal(true);
          } else {
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {
              type: response.headers["content-type"],
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        setApiError({ isVisible: true, message: showError(error) });
      });
  };

  const generatePagoPA = () => {
    setLoading(false);
    Repo.sendMyPay(
      apiToken,
      id,
      paymentReferenceDate,
      null,
      null,
      null,
      filterSubscribed,
    )
      .then((response) => {
        if (response.status === 200) {
          setLoading(true);
          toggleModalCSVUpload(!isOpenCSVUpload);
          setAlertShow(true);
          setAlertMessage("Bollettini generati correttamente");
        }
      })
      .catch((error) => {
        setLoading(true);

        setApiError({ isVisible: true, message: showError(error) });
        toggleModalCSVUpload(!isOpenCSVUpload);
      });
  };

  const sendNotifyAll = (tipoNotifica) => {
    setLoading(false);
    Repo.notifyAll(apiToken, id, filterMonth, tipoNotifica, filterSubscribed)
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        console.error(error);
        setLoading(true);
      });
  };

  const sendRendicontazione = () => {
    setLoading(false);
    Repo.getRendicontazione(apiToken, id)
      .then((response) => {
        if (response.status == 200) {
          setLoading(true);
          toggleModalRendicontazione(!isOpenRendicontazione);
          setAlertShow(true);
          setAlertMessage("La rendicontazione è in corso");
        }
      })
      .catch((error) => {
        setLoading(true);
        setApiError({ isVisible: true, message: showError(error) });
        toggleModalRendicontazione(!isOpenRendicontazione);
      });
  };

  // Funzione per abbreviare il nome del file
  const abbreviateFileName = (fileName) => {
    const maxLength = 25;
    const extension = fileName.split(".").pop(); // Ottieni l'estensione del file
    const baseName = fileName.substring(0, fileName.lastIndexOf("."));

    if (baseName.length > maxLength) {
      return `${baseName.substring(0, maxLength)}...${extension}`;
    }
    return fileName;
  };

  const fileListDownload = () => {
    return (
      <>
        {session.announcementFiles && session.announcementFiles.length > 0 && (
          <>
            <h4 className="mt-4">Allegati</h4>
            <div className="row mt-4">
              {session.announcementFiles.map((x) => (
                <React.Fragment key={x.storageFileId}>
                  <div className="col-3">
                    <button
                      className="btn btn-lg"
                      onClick={() => showFile(x.storageFileId, x.name)}
                      title={x.name}
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-file`} />
                      </svg>{" "}
                      {abbreviateFileName(x.name)}
                    </button>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </>
        )}
      </>
    );
  };

  const buttonStyle = {
    maxWidth: "200px",
    minWidth: "200px",
    maxHeight: "50px",
    minHeight: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <>
      <div className="container mb-1 shadow-sm p-3 bg-white">
        <h1>Intervento</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Scheda di riepilogo dell'intervento - ({session.name})</p>
        </div>
        {apiError.isVisible && (
          <AlertMessage
            isVisible={apiError.isVisible}
            onClose={handleAlertClose}
            error={apiError.message}
          />
        )}
        {!props.isDelegate && (
          <div className="row">
            <div className="col-lg-12 text-right">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() =>
                  (window.location.href =
                    props.subfolder +
                    "/lista_interventi/dettaglio_intervento/modifica_intervento?sessionId=" +
                    session.id)
                }
              >
                <span className="align-middle">Modifica intervento</span>
              </button>
            </div>
          </div>
        )}

        <hr />
        {session ? (
          <>
            <div className="row">
              <div className="col-lg-5">
                Intervento:{" "}
                <span className="text">
                  <b>{session.name}</b>
                </span>
              </div>
              <div className="col-lg-3 text-right">
                Stato:{" "}
                <span className="text">
                  <b>
                    <StateTranslate text={session.state} trasform="U" />
                  </b>
                </span>
              </div>
              {service && (
                <>
                  <div className="col-lg-4 text-right">
                    Categoria:{" "}
                    <span className="text">
                      <b>{service.name} </b>
                    </span>
                  </div>
                </>
              )}
            </div>
            <hr className="pb-1" />
            <div className="row ">
              <div className="col-lg-3">
                {labels.hasPresenze}:{" "}
                <span className="text">
                  <b>{session && session.hasPresenze ? "SI" : "NO"} </b>
                </span>
              </div>

              <div className="col-lg-3">
                {labels.hasPayment}:{" "}
                <span className="text">
                  <b>{session && session.hasPayment ? "SI" : "NO"} </b>
                </span>
              </div>
            </div>

            {fileListDownload()}
          </>
        ) : (
          <>
            <span className="text">
              L'intervento selezionato non è presente.
            </span>
          </>
        )}
      </div>
      <div
        className="container shadow-sm p-3 mb-5 bg-white rounded"
        style={{ maxWidth: "1500px" }}
      >
        {session &&
        (session.btbPresenze ||
          session.btbMoney ||
          session.hasPayment ||
          session.hasCoupon ||
          session?.service?.tipoServizio === 3) ? (
          <>
            <div
              className="row"
              style={{ backgroundColor: "#f4f4f4", padding: "10px" }}
            >
              {session && session.btbMoney ? (
                <div className="col text-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary p-2"
                    onClick={() =>
                      history.push(
                        `/lista_interventi/dettaglio_intervento/lista_presenze/${session.id}`,
                      )
                    }
                  >
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-card`} />
                    </svg>{" "}
                    <span className="align-middle">{labels.btbMoney}</span>
                  </button>
                </div>
              ) : null}

              {session && session.hasPresenze ? (
                <div className="col text-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary p-2"
                    onClick={() =>
                      history.push(
                        `/lista_interventi/dettaglio_intervento/lista_presenze/${session.id}`,
                      )
                    }
                  >
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-calendar`} />
                    </svg>{" "}
                    <span className="align-middle">{labels.btbPresenze}</span>
                  </button>
                </div>
              ) : null}

              {session && session.hasPayment ? (
                <>
                  {" "}
                  <div className="col-4 offset-md-4 text-center">
                    <label htmlFor="mese" className="form-label">
                      <strong>Seleziona mese</strong>
                    </label>
                    <select
                      id="mese"
                      name="mese"
                      className="form-control custom-textarea"
                      value={filterMonth}
                      onChange={(e) => setFilterMonth(e.target.value)}
                    >
                      {session?.anno ? (
                        <>
                          <option value="01">Gennaio ({session?.anno})</option>
                          <option value="02">Febbraio ({session?.anno})</option>
                          <option value="03">Marzo ({session?.anno})</option>
                          <option value="04">Aprile ({session?.anno})</option>
                          <option value="05">Maggio ({session?.anno})</option>
                          <option value="06">Giugno ({session?.anno})</option>
                          <option value="07">Luglio ({session?.anno})</option>
                          <option value="08">Agosto ({session?.anno})</option>
                          <option value="09">
                            Settembre ({session?.anno})
                          </option>
                          <option value="10">Ottobre ({session?.anno})</option>
                          <option value="11">Novembre ({session?.anno})</option>
                          <option value="12">Dicembre ({session?.anno})</option>
                          <option value="13">
                            Gennaio ({session?.anno + 1})
                          </option>
                          <option value="14">
                            Febbraio ({session?.anno + 1})
                          </option>
                          <option value="15">
                            Marzo ({session?.anno + 1})
                          </option>
                          <option value="16">
                            Aprile ({session?.anno + 1})
                          </option>
                          <option value="17">
                            Maggio ({session?.anno + 1})
                          </option>
                          <option value="18">
                            Giugno ({session?.anno + 1})
                          </option>
                          <option value="19">
                            Luglio ({session?.anno + 1})
                          </option>
                          <option value="20">
                            Agosto ({session?.anno + 1})
                          </option>
                          <option value="21">
                            Settembre ({session?.anno + 1})
                          </option>
                          <option value="22">
                            Ottobre ({session?.anno + 1})
                          </option>
                          <option value="23">
                            Novembre ({session?.anno + 1})
                          </option>
                          <option value="24">
                            Dicembre ({session?.anno + 1})
                          </option>
                        </>
                      ) : (
                        <>
                          <option value="01">Gennaio</option>
                          <option value="02">Febbraio</option>
                          <option value="03">Marzo</option>
                          <option value="04">Aprile</option>
                          <option value="05">Maggio</option>
                          <option value="06">Giugno</option>
                          <option value="07">Luglio</option>
                          <option value="08">Agosto</option>
                          <option value="09">Settembre</option>
                          <option value="10">Ottobre</option>
                          <option value="11">Novembre</option>
                          <option value="12">Dicembre</option>
                        </>
                      )}
                    </select>
                  </div>
                  <div className="col-4 offset-md-1 pt-4">
                    <button
                      className="btn btn-outline-primary mb-2"
                      onClick={() => setShowFiles(!showFiles)}
                    >
                      {showFiles
                        ? "Nascondi cronologia pagamenti"
                        : "Mostra cronologia pagamenti"}
                    </button>
                  </div>
                  <div className="col-2 offset-md-1 text-center pt-4">
                    <button
                      type="button"
                      className="btn btn-outline-primary p-2"
                      onClick={() => {
                        toggleModalCSVUpload(!isOpenCSVUpload);
                      }}
                      style={buttonStyle}
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-card`} />
                      </svg>{" "}
                      <span className="align-middle">{labels.inviaCsv}</span>
                    </button>
                  </div>
                  <div className="col-2 text-center pt-4">
                    <button
                      type="button"
                      className="btn btn-outline-primary p-2"
                      onClick={() => {
                        toggleModalCSVEmail(!isOpenCSVEmail);
                      }}
                      style={buttonStyle}
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-mail`} />
                      </svg>{" "}
                      <span className="align-middle">Invia notifica email</span>
                    </button>
                  </div>
                  <div className="col-2 text-center pt-4">
                    <button
                      type="button"
                      className="btn btn-outline-primary p-2"
                      onClick={() => {
                        toggleModalCSVIO(!isOpenCSVIO);
                      }}
                      style={buttonStyle}
                    >
                      <div className="align-middle">
                        Invia notifica
                        <img src={IO} className="ml-1  img-io" />
                      </div>
                    </button>
                  </div>
                  <div className="col-12">{renderPaymentFiles()}</div>
                </>
              ) : null}

              {session?.service?.tipoServizio === 3 && (
                <>
                  <div className="col-2"></div>
                  <div className="col-4">
                    <label htmlFor="mese" className="form-label">
                      <strong>Seleziona mese</strong>
                    </label>
                    <select
                      id="mese"
                      name="mese"
                      className="form-control custom-textarea"
                      value={filterMonth}
                      onChange={(e) => setFilterMonth(e.target.value)}
                    >
                      <option value="01">Gennaio</option>
                      <option value="02">Febbraio</option>
                      <option value="03">Marzo</option>
                      <option value="04">Aprile</option>
                      <option value="05">Maggio</option>
                      <option value="06">Giugno</option>
                      <option value="07">Luglio</option>
                      <option value="08">Agosto</option>
                      <option value="09">Settembre</option>
                      <option value="10">Ottobre</option>
                      <option value="11">Novembre</option>
                      <option value="12">Dicembre</option>
                    </select>
                  </div>
                </>
              )}

              {session.hasCoupon && (
                <div className="col text-center">
                  <button
                    type="button"
                    className="btn btn-outline-success text-success  p-2"
                    onClick={() => {
                      toggleModalCoupon(!isOpenCoupon);
                    }}
                  >
                    <svg className="icon icon-success">
                      <use href={`${iconSprite}#it-exchange-circle`} />
                    </svg>{" "}
                    <span className="align-middle">{labels.generaCoupon}</span>
                  </button>
                </div>
              )}
            </div>
          </>
        ) : null}
        <ListUsers
          toggleModalImport={toggleModalImport}
          isOpenImport={isOpenImport}
          downloadList={downloadList}
          setFilterSubscribed={setFilterSubscribed}
          filterSubscribed={filterSubscribed}
          sessionSubscriptionTemp={sessionSubscriptionTemp}
          sessionSubscriptionTemp2={sessionSubscriptionTemp2}
          setSessionSubscriptionTemp={setSessionSubscriptionTemp}
          setSessionSubscriptionTemp2={setSessionSubscriptionTemp2}
          session={session}
          sessionSubscription={sessionSubscription}
          setSessionSubscription={setSessionSubscription}
          changeArray={changeArray}
          toggleModal={toggleModal}
          isOpen={isOpen}
          apiGet={apiGet}
          setSub={setSub}
          sub={sub}
          filterMonth={filterMonth}
          getMonthName={getMonthName(filterMonth)}
          isExternalLock={!!session.externalId}
          isDelegate={props.isDelegate}
          isOperator={props.isOperator}
          bands={session.bands}
        ></ListUsers>
      </div>

      {/* Modali */}
      <Modal
        isOpen={isOpen}
        toggle={() => toggleModal(!isOpen)}
        size={"lg"}
        labelledBy="Modale1"
        className="modalFit"
        style={{ top: "20%" }}
      >
        <ModalHeader id="Modale1">Iscrivi Utente</ModalHeader>
        <ModalBody>{returnBodyModal()}</ModalBody>
        <ModalFooter>
          <Button
            color="info text-white"
            onClick={() => {
              toggleModal(!isOpen);
              setUsersList([]);
            }}
          >
            Indietro
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={isOpenSubscribeUserOperator}
        toggle={() =>
          toggleModalSubscribeUserOperator(!isOpenSubscribeUserOperator)
        }
        size={"lg"}
        labelledBy="Modale1"
        className="modalFit"
        style={{ top: "20%" }}
      >
        <ModalHeader id="Modale1">Iscrivi Utente</ModalHeader>
        <ModalBody>
          <div className="row p-2">
            <p>Sei sicuro di voler iscrivere l'utente all'intervento ?</p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary text-white text-center"
            onClick={() => subscribeUser(sub)}
          >
            Conferma
          </Button>
          <Button
            color="info text-white text-center"
            onClick={() => {
              toggleModalSubscribeUserOperator(!isOpenSubscribeUserOperator);
            }}
          >
            Indietro
          </Button>
        </ModalFooter>
      </Modal>

      <ModalComponent
        toggleModal={toggleModalCSVUpload}
        isOpen={isOpenCSVUpload}
        header={labels.inviaCsv}
        body={
          <>
            Premere <strong className="mr-1">Conferma</strong>
            per la generazione dei bollettini del mese di{" "}
            <b>{getMonthName(filterMonth)}</b>
            <br />
            <br />
            Puoi anche scaricare e visualizzare l'<strong>
              anteprima
            </strong>{" "}
            degli utenti interessati
            <div className="text-center">
              <button
                type="button"
                className="btn btn-primary mt-3"
                onClick={downloadPreview}
              >
                <svg className="icon icon-white mr-1">
                  <use href={`${iconSprite}#it-download`} />
                </svg>
                Scarica anteprima
              </button>
            </div>
          </>
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => generatePagoPA()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalCSVEmail}
        isOpen={isOpenCSVEmail}
        header={labels.inviaCsv}
        body={
          <>
            Premere <strong className="mr-1">Conferma</strong>
            per inviare le notifiche <strong className="mr-1">email</strong> dei
            bollettini generati nel mese di <b>{getMonthName(filterMonth)}</b>
            <br />
            <br />
            Puoi anche scaricare e visualizzare l'<strong>
              anteprima
            </strong>{" "}
            degli utenti interessati
            <div className="text-center">
              <button
                type="button"
                className="btn btn-primary mt-3"
                onClick={downloadPreviewNotify}
              >
                <svg className="icon icon-white mr-1">
                  <use href={`${iconSprite}#it-download`} />
                </svg>
                Scarica anteprima
              </button>
            </div>
          </>
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendNotifyAll("EMAIL")}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalCSVIO}
        isOpen={isOpenCSVIO}
        header={labels.inviaCsv}
        body={
          <>
            Premere <strong className="mr-1">Conferma</strong>
            per inviare le notifiche su <strong className="mr-1">AppIO</strong>
            dei bollettini generati nel mese di{" "}
            <b>{getMonthName(filterMonth)}</b>
            <br />
            <br />
            Puoi anche scaricare e visualizzare l'<strong>
              anteprima
            </strong>{" "}
            degli utenti interessati
            <div className="text-center">
              <button
                type="button"
                className="btn btn-primary mt-3"
                onClick={downloadPreviewNotify}
              >
                <svg className="icon icon-white mr-1">
                  <use href={`${iconSprite}#it-download`} />
                </svg>
                Scarica anteprima
              </button>
            </div>
          </>
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendNotifyAll("IO")}
      ></ModalComponent>

      <ModalComponent
        toggleModal={() => toggleModalShowFile(!showFileToggle)}
        isOpen={showFileToggle}
        header={"File"}
        body={bodyFile()}
        buttonDeny="Chiudi"
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalRendicontazione}
        isOpen={isOpenRendicontazione}
        header="Rendicontazione"
        body="Saranno associati i pagamenti agli utenti iscritti e potrai visualizzare lo stato dei pagamenti"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendRendicontazione()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalCoupon}
        isOpen={isOpenCoupon}
        header="Buoni servizio"
        body={bodyGenerateCoupons()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendGenerateCoupons()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalImport}
        isOpen={isOpenImport}
        header="Import dati utenti"
        body={bodyImport()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => uploadList()}
      ></ModalComponent>

      {subscribeError && (
        <div
          className="alert alert-danger"
          role="alert"
          style={{
            position: "fixed",
            backgroundColor: "white",
            bottom: "0px",
            right: "5px",
            zIndex: "10000",
          }}
        >
          {alertMessage}
        </div>
      )}

      {alertShow && (
        <div
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.5)",
            zIndex: 20000,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
          }}
          aria-modal="true"
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{ maxWidth: 400 }}
          >
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-body text-center py-4">
                <div className="mb-3">
                  <svg
                    className="icon icon-success"
                    style={{ width: 60, height: 60 }}
                  >
                    <use href={`${iconSprite}#it-check-circle`} />
                  </svg>
                </div>
                <h4 className="text-success mb-3">Operazione completata</h4>
                <p style={{ fontSize: "1.2rem" }}>{alertMessage}</p>
                <button
                  className="btn btn-success btn-lg mt-4 px-5"
                  onClick={() => window.location.reload()}
                  autoFocus
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {!loading && <Loader></Loader>}
    </>
  );
}

export default AnnouncementDetail;
